export const shippingMethodLadProps = () => ({
  service: {
    type: Object,
    required: true
  },
  addresseLad: {
    type: Object,
    required: false
  },
  idAddressLivraison: {
    type: [Number, String],
    required: false,
    default: null
  },
  eligibleAlerteSms: {
    type: Boolean,
    required: false,
    default: false
  },
  isEligibleAbonnementLad: {
    type: Boolean,
    required: false,
    default: false
  },
  abonnementsMeta: {
    type: Object,
    required: false,
    default: {}
  },
  magasinId: {
    type: [Number, String],
    required: false,
    default: null
  },
  hasAbonnementInPanier: {
    type: Boolean,
    required: false,
    default: false
  },
  abonnements: {
    type: Array,
    required: true
  },
  tarifLad: {
    type: Number,
    required: false,
    default: 8.9
  },
  shippingMode: {
    type: String,
    required: false,
    default: ""
  },
  consigneSacs: {
    type: Boolean,
    required: false,
    default: false
  },
  isSacOffert: {
    type: Boolean,
    required: false,
    default: false
  },
  infosModeCommande: {
    type: Object,
    required: false,
    default: null
  }
})

export const useShippingMethodLad = (props) => {
  const abonnementInCurrentMagasin = computed(() => {
    return props.abonnements.find(abo => abo.attributes.magasin_id === props.magasinId)
  })
  const showBanniereEuroPlus = computed(() => {
    return props.tarifLad >= 8.9 && props.isEligibleAbonnementLad && !(abonnementInCurrentMagasin.value || props.hasAbonnementInPanier)
  })

  const montantSac = computed(() => {
    return props.infosModeCommande && props.infosModeCommande.consigne_sacs && props.infosModeCommande.consigne_sacs.montant_unitaire
  })

  return { abonnementInCurrentMagasin, showBanniereEuroPlus, montantSac }
}
